<template>
    <div id="modal-addGuest" class="modal">
        <button data-iziModal-close class="icon-close">
            <svg><use xlink:href="#i_close"></use></svg>
            <span class="sr-only">{{ $t('close') }}</span>
        </button>
        <div>
            <h2>{{ $t('addGuest_2') }}</h2>
            <form class="addGuestForm" method="post" onsubmit="return window.addGuest()">
                <input type="hidden" v-model="quantity" name="quantity" id="gQuantity" data-id="quantity">
                <input type="hidden" name="event" data-id="eventID">
                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="guestNameEdit">{{ $t('guestName') }}</label>
                            <input type="text" id="guestNameEdit" name="guestNameEdit" data-id="fullName" required>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="row secondLevel">
                            <div class="col-md-6 col-xs-12">
                                <label>{{ $t('quantity') }}</label>
                                <div class="guestCounter">
                                    <span class="plus" onclick="window.guestQuantityChange('+')"><svg><use xlink:href="#i_plus"></use></svg></span>
                                    <span class="value vQyt">{{ quantity }}</span>
                                    <span class="minus" onclick="window.guestQuantityChange('-')"><svg><use xlink:href="#i_minus"></use></svg></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="companyEdit">{{ $t('company') }} {{ $t('conferenceOnly') }}</label>
                            <input type="text" id="companyEdit" name="companyEdit" data-id="company">
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="roleEdit">{{ $t('role') }} {{ $t('conferenceOnly') }}</label>
                            <input type="text" id="roleEdit" name="roleEdit" data-id="role">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-xs-12" v-if="!$store.state.isTablet">
                        <div class="inputWrap">
                            <label for="groupName">{{ $t('groupName') }}</label>
                            <input type="text" id="groupName" name="groupName" data-id="_group">

                        </div>

                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="guestTable">{{ $t('tableNum') }}</label>
                            <input type="tel" id="guestTable" name="guestTable" data-id="tableNumber">
                        </div>
                    </div>
                </div>

                <div class="row" v-bind:style="$store.state.isTablet ? 'margin-bottom:10px' : ''">
                    <div class="col-md-2 col-xs-12">
                        <div class="inputWrap">
                            <label for="isArrived">{{ $t('isArrived') }}</label>
                            <input type="checkbox" id="isArrived" name="isArrived" data-id="arrived" v-bind:style="$store.state.isTablet ? '-webkit-appearance:checkbox' : ''">
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!$store.state.isTablet">
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="guestEmail">{{ $t('email') }}</label>
                            <input type="email" id="guestEmail" name="guestEmail" data-id="email">
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="guestPhone">{{ $t('phone') }}</label>
                            <input type="tel" id="guestPhone" name="guestPhone" data-id="phone">
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!$store.state.isTablet">
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="note">{{ $t('notes') }}</label>
                            <input type="text" id="note" name="note" data-id="note">

                        </div>

                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="inputWrap">
                            <label for="printNote">{{ $t('printNote') }}</label>
                            <input type="tel" id="printNote" name="printNote" data-id="printNote">
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-6 col-xs-12 pull-left">
                        <div class="inputWrap submitWrap">
                            <button class="submit" type="submit">{{ $t('addGuest_3') }}</button>
                        </div>
                    </div>
                </div>

            </form>
            <div v-if="showLoader" class="modalLoader">
                <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    export default {
        name: "AddGuestModal",
        props:['addGuestEvent'],
        data(){
            return{
                fullName:'',
                email:'',
                company:'',
                role:'',
                phone:'',
                eventID:'',
                note:'',
                printNote:'',
                groupID:'',
                tableNumber:'',
                _group:'',
                quantity:1,
                arrived:false,
                isReserve:false,
                showLoader:false,
            }
        },
        components:{
            RotateLoader
        },
        mounted(){
            let _this = this;
            window.addGuest = function(){
                _this.showLoader = true;
                $('.addGuestForm').find('input,select').each(function(){
                    if($(this).attr('type') === "checkbox"){
                        _this[$(this).data('id')] = $(this).is(":checked");
                    }else {
                        _this[$(this).data('id')] = $(this).val();
                    }
                });
                _this.save();
                return false;
            }

            window.guestQuantityChange = function(action = '+'){
                let quantity = parseInt($("#gQuantity").val());
                if(isNaN(quantity)) quantity = 1;
                if(action == '+'){
                    quantity++;
                }else{
                    if(quantity>1) quantity--;
                }
                $('.vQyt').text(quantity);
                $("#gQuantity").val(quantity)
            };
        },
        methods:{
            save(){
                this.$data._group = $('#groupName').val();
                if(this.$store.state.isTablet) {
                    this.$data.status = {
                        coming: parseInt(this.$data.quantity),
                        notResponded: 0
                    };
                } else {
                    this.$data.status = {
                        notResponded: parseInt(this.$data.quantity),
                        coming: 0
                    };
                }
                this.$store.dispatch('addGuest',this.$data)
                                        .then(gData =>{
                                            //success
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'success',
                                                title:this.$t('guestSaved'),
                                                timer:2000
                                            }).catch(this.$swal.noop);
                                            this.$emit('addGuest',gData)
                                            this.showLoader = false;
                                            $('.addGuestForm #gQuantity').val('1');
                                            $('.addGuestForm .value.vQyt').text("1");
                                            $("#modal-addGuest").iziModal({
                                                autoOpen: 1,
                                            });
                                            $('.addGuestForm').find('input,select').each(function(){
                                               $(this).val('')
                                            });
                                        })
                                        .catch(err => {
                                            //err
                                            this.showLoader = false;
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'error',
                                                title:this.$t('saveFailed'),
                                                timer:3000
                                            }).catch(this.$swal.noop);
                                        })
            },
        }
    }
</script>
<style scoped>

    h2{
        color:#7893c1;
        font-size: 1.706rem;
        font-weight: 700;
    }
    h3{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .h1Wrap .i_users{
        width:36px;
        height:28px;
    }
    .innerBox{
        padding:23px;
    }
    .innerBox.filterBox{
        padding:23px;
    }

    .innerBox.filterBox h3{
        display: inline-block;
        vertical-align: middle;
    }
    .innerBox.filterBox h3 span{
        color:#293b5a;
        font-size: 1rem;
        display: block;
        font-weight: 700;
        margin-top:10px;
    }
    .innerBox.filterBox h3 svg{
        width:24px;
        height:24px;
        display: block;
        margin:0 auto;
        fill:#293b5a;
    }
    .innerBox.filterBox .inputWrap{
        display: inline-block;
        vertical-align: middle;
        margin-right:15px;
        width:250px;
    }
    .innerBox.filterBox .inputWrap.statusBarWrap{
        width:530px;
    }
    .innerBox.filterBox  .inputWrap + .inputWrap{
        margin-top:0;

    }
    .innerBox.filterBox .inputWrap label{
        color:#293b5a;
        font-size: 0.8824rem;
        font-weight: bold;
    }
    .innerBox.filterBox .inputWrap input,
    .innerBox.filterBox .inputWrap select{
        background:#fff;
        color:#434343;
        height:43px;
        line-height: 40px;
    }
    .innerBox.filterBox .inputWrap select#eventStatus{
        background: #f6f6f6
    }
    .innerBox.filterBox .inputWrap.searchWrapper{
        width:335px;
    }
    .innerBox.filterBox .inputWrap.searchWrapper input{
        padding-left: 40px;
    }
    .innerBox.filterBox .inputWrap.searchWrapper .searchEvent{
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
    }
    .innerBox.filterBox .inputWrap.searchWrapper .searchEvent svg{
        fill: #293b5a;
        width: 18px;
        height: 20px;
        display: block;
    }
    .orDivider{
        display: inline-block;
        height: 43px;
        width: 43px;
        line-height: 43px;
        text-align: center;
        border-radius: 50%;
        background: #e0e0e0;
        color: #414141;
        font-size: 1rem;
        font-style: italic;
        margin: 0px 15px;
        vertical-align: bottom;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions button{
        width: 181px;
        height: 42px;

        border-radius: 21px;
    }
    .addGuest{
        border: 1px solid #52dbcd;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .addGuest svg{
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        height: 24px;
        fill: #fff;
        margin-left: 5px;
    }
    .addGuest span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }
    .pullExcel{
        width: 215px!important;
        border: 1px solid #44536e;
        margin-left: 10px;
    }
    .pullExcel svg{
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        height: 24px;
        margin-left: 5px;
        fill:#7b96c4;
    }
    .pullExcel span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#44536e;
    }
    .statusBar{
        width: 530px;
        height: 43px;
        line-height: 40px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        display: inline-block;
        vertical-align: middle;
    }
    .statusBtn{
        float: right;
        width:20%;
        text-align: center;
        padding: 0 5px;
    }
    #all span{
        color:#293b5a;
        font-weight: 700;
    }
    #all{
        border-radius: 27px 0 0 27px;
    }
    .statusBar .active{
        background: #f3f3f3 !important;
    }
    .statusBtn svg{
        width:24px;
        height:24px;
        display: inline-block;
        vertical-align: middle;
        margin-left:5px;
    }
    .statusBtn span{
        color:#555555;
        font-size: 0.8235rem;
        display: inline-block;
        vertical-align: middle;
    }
    svg.i_arriving{
        fill:#41b53e;
    }
    svg.i_notArriving{
        fill:#bb1b1b;
    }
    svg.i_maybeArriving{
        fill:#e49e9e;
    }
    svg.i_didentAnswer{
        fill:#656565;
    }
    .guestsTable{
        width:100%;
        float: right;
        margin-top:25px;
        position:relative;
    }
    .guestsTable table{
        width:100%;
        border-spacing: 1px;
    }
    .guestsTable table tr:first-child{
        border-bottom:1px solid #293b5a;

    }
    .guestsTable table tr th{
        padding:15px;
        color:#7b96c4;
        font-weight:700;
        font-size: 1.059rem;
    }
    .guestsTable table tr td{
        padding:13px;
        color:#5a5a5a;
        font-size:1rem;
        position: relative;

    }
    .guestsTable table tr td label + label:before{
        content:"|";
        padding:0 5px;
    }
    .guestsTable table tr td label.longTxt{
        width:100%;
        min-width: 150px;
    }
    .guestCounter{
        width: 110px;
        max-width: 100%;
        height: 44px;
        line-height: 40px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        float: right;
    }
    .guestCounter span,
    .guestCounter input{
        width:33.3%;
        float: right;
        text-align: center;
        height: 100%;
    }
    .guestCounter span.plus{
        background: #f2f2f2;
        border-radius: 0 27px 27px 0;
    }
    .guestCounter span.minus{
        background: #f2f2f2;
        border-radius: 27px 0 0 27px;
    }
    .guestCounter span svg{
        width: 17px;
        height: 100%;
        fill: #293b5a;
        display: block;
        margin:0 auto;
    }
    .guestCounter input.value{
        font-size: 1rem;
        color: #434343;
        background: #fff;
    }
    .editibleEl{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
        opacity: 0;
        z-index: -1;
        border: 1px solid #bfc1c5;
        border-radius: 27px;
        display: block;
        background: #fff;
        width: 90%;
        height: 44px;
        padding-right: 7px;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    .counterPop{
        min-width: 85px;
    }
    .innerMainContent .guestCounter:not(.innerCounter).active,
    .editibleEl:focus {
        z-index: 1;
        opacity: 1;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    .innerMainContent .guestCounter:not(.innerCounter){
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
        opacity: 0;
        z-index: -1;
        border: 1px solid #bfc1c5;
        border-radius: 27px;
        display: block;
        background: #fff;
        width: 90%;
        height: 44px;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    .guestsTable table tr{
        background: #fff;
        /*border:1px solid transparent;*/

    }
    .guestsTable table tr:nth-child(2n+2){
        background: #f0f0f0;
    }
    .deleteGuest svg{
        width:18px;
        height:19px;
        fill:#293b5a;
    }
    .pagination{
        width:100%;
        float: right;
    }
    .pagination .side1{
        float: right;
    }
    .pagination .side1 label{
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 0px;
        margin-left:10px;
        font-weight: 700;
        color:#293b5a;
        font-size: 0.8235rem;
    }
    .pagination .side1 select{
        width: 74px;
        height: 34px;
        background: #fff;
        border-radius: 27px;
        color: #666666;
        font-size: 0.8235rem;
        padding: 0 10px 0 20px;
        border-color: #7993c0;
    }
    .pagination .side1 .selectWrap{
        display: inline-block;
        margin-left: 10px;
    }
    .pagination .side1 .goustsTotalRows,
    .pagination .side1 .goustsTxt{
        color:#000000;
        font-weight: 700;
        font-size: 0.8235rem;
    }
    .pagination .side1 .goustsRows,
    .pagination .side1 .outOfTxt{
        color:#000000;
        font-weight: 400;
        font-size: 0.8235rem;
    }

    .pagination .side1 .selectWrap .i_select{
        width: 11px;
        height: 6px;
        top: calc(50% - 2px);
        fill: #293b5a;
        left: 13px;
    }
    .pagination .side2{
        float: left;
    }
    .pagination .side2 .prev svg,
    .pagination .side2 .next svg{
        width:11px;
        height:6px;
        fill:#293b5a;
    }
    .pagination .side2 .prev.disabled svg,
    .pagination .side2 .next.disabled svg{
        fill:#adadad;
    }
    .pagination .side2 .prev{
        transform: rotate(-90deg);
        display: inline-block;
        vertical-align:middle;
    }
    .pagination .side2 .next{
        transform: rotate(90deg);
        display: inline-block;
        vertical-align:middle;
    }
    .pagination .side2 ul li,
    .pagination .side2 ul{
        display: inline-block;
        vertical-align: middle;
    }
    .pagination .side2 ul li button{
        width:31px;
        height:31px;
        line-height: 30px;
        border: 1px solid transparent;
        border-radius: 50%;
        text-align: center;
        color:#000000;
        font-size: 0.8235rem;
    }
    .pagination .side2 ul li.active button{
        background: #fff;
        border-color:#7791be;
        color:#7791be;
    }
    .g_status svg{
        width:21px;
        height:21px;
    }
    .g_status>span{
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        color:#8e8e8e;
        font-size: 0.6471rem;
        margin:0 2px;
    }
    .g_status_drop{
        position: absolute;
        top: calc(100% - 10px);
        background: #fff;
        border: 1px solid #bfc1c5;
        display: none;
        z-index: 1;
    }
    .active .g_status_drop{
        display: block;
    }
    .g_status_drop svg{
        width:25px;
        height:25px;
        display: inline-block;
        vertical-align: middle;

    }
    .g_status_drop span{
        display: inline-block;
        vertical-align: middle;
        color:#1c1c1c;
        font-size: 0.9412rem;
    }
    .g_status_drop .yes,
    .g_status_drop .no,
    .g_status_drop .maybe,
    .g_status_drop .noAnswer{
        float: right;
    }
    .yes svg{fill:#44b642;}
    .no svg{fill:#ba1818;}
    .maybe svg{fill:#e5a2a2;}
    .noAnswer svg{fill:#797979;}
    .guestCounter.innerCounter{
        float: left;
        width: 71px;
        height: 30px;
        line-height: 28px;
    }
    .guestCounter.innerCounter span svg{
        width:9px;
    }
    .g_status_drop ul{
        width:180px;
    }
    .g_status_drop ul li{
        float: right;
        width:100%;
        padding: 5px;
    }
    .g_status_drop ul li:nth-child(even){
        background: #f0f0f0;
    }
    .guestCounter.innerCounter span.plus,
    .guestCounter.innerCounter span.minus{
        background: #fff;
    }
    .guestCounter.innerCounter span.value{
        background: #fff;
        border-right:1px solid #bfc1c5;
        border-left:1px solid #bfc1c5;
    }
    .g_status{

        border-radius: 27px;
    }
    .active .g_status{
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #bfc1c5;

    }
    .textInputPop + .selectWrap svg{
        display: none;
    }
    .textInputPop + .selectWrap select:focus + svg{
        display: block;
    }
    .textInputPop + .selectWrap{
        position: static;
    }
    .textInputPop + .selectWrap .i_select{
        z-index: 9;
        width: 11px;
        height: 6px;
        top: calc(50% - 2px);
        left: 30px;
    }
    .g_info svg{fill:#000;height:18px;}
    .gender svg{width:14px;}
    .crown svg{width:21px;}
    .access svg{width:15px;}
    .veg svg{width:17px;}
    .kosher svg{width:16px;}
    .g_info_drop ul{}
    .g_info_drop ul li{
        display: inline-block;
        vertical-align: middle;
        width: 20%;
        background: #fff!important;
    }

    .g_callWrap svg{
        width:22px;
        height:22px;
        display: block;
        margin:0 auto;
    }
    .g_callWrap .noCall svg{fill:#ff0000;}
    .g_callWrap .yesCall svg{fill:#2edf71;}
    .g_callWrap ul{
        position: absolute;
        top: 50%;
        right:50%;
        transform: translate(50%,-50%);
        border: 1px solid #bfc1c5;
        border-radius: 27px;
        background: #fff;
        display: none;
    }
    .g_callWrap ul.active{
        display: block;
    }
    .g_callWrap{
        text-align: center;

    }
    .g_callWrap ul li{
        padding:10px;
    }
    .g_callWrap ul li button{
        display: block;
    }
    .g_callWrap ul li + li{
        border-top: 1px solid #bfc1c5;
        background: #f0f0f0;
        border-radius: 0 0 27px 27px;
    }


    #modal-addGuest{
        max-width: 600px!important;
        background: #efefef;
    }
    #modal-addGuest .row + .row{
        margin-top:20px;
    }
    #modal-addGuest .inputWrap input, #modal-addGuest .inputWrap select, #modal-addGuest{
        background: #fff;
        color:#555555;
        font-size: 0.8235rem;
    }
    #modal-addGuest h2{
        color:#293b5a;
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 20px;
    }

    #modal-addGuest label{
        color:#434343;
        font-size: 1rem;
        margin-bottom: 10px;
        display: block;
    }

    #modal-addGuest .statusDropDown li{
        padding:7px 0;
        cursor: pointer;
    }
    #modal-addGuest .selectedValue span svg,
    #modal-addGuest .statusDropDown li svg{
        width:24px;
        height:24px;
        vertical-align: middle;
        display: inline-block;
        margin-left:7px;
    }
    #modal-addGuest .selectedValue span span,
    #modal-addGuest .statusDropDown li span{
        vertical-align: middle;
        display: inline-block;
        color:#555555;
        font-size: 0.8235rem;
    }
    #modal-addGuest .selectedValue{
        width: 100%;
        height: 54px;
        line-height: 54px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        background: #fff;
        padding: 0 15px;
        color: #fff;
    }
    #modal-addGuest .statusDropDown{
        z-index: 1;
        background: #fff;
        width: 125px;
        padding: 0 10px;
        border: 1px solid #dddddd;
        position: absolute;
        top: calc(100% + 15px);
        right: 50%;
        transform: translateX(50%);
        display: none;
    }
    #modal-addGuest .statusDropDown.open{
        display: block;
    }
    #modal-addGuest .statusDropDown:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #dddddd;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 6px);
    }
    #modal-addGuest .statusDropDown:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 4px);
    }
    #modal-addGuest .secondLevel{
        margin:0 -7px;
    }
    #modal-addGuest .secondLevel div[class^="col-"]{
        padding:0 7px;
    }
    #modal-addGuest .selectedValue{
        position: relative;
    }
    #modal-addGuest .selectedValue .i_select{
        width:16px;
        height:9px;
        position:absolute;
        top:calc(50% - 4px);
        left:10px;
        fill:#8798b5;
    }
    #modal-addGuest .guestCounter{
        width: 100%;
        height: 54px;
        line-height: 52px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        float: right;
    }
    #modal-addGuest .guestCounter span{
        width:33.3%;
        float: right;
        text-align: center;
        height: 100%;
    }
    #modal-addGuest .guestCounter span.plus{
        background: #f2f2f2;
        border-radius: 0 27px 27px 0;
    }
    #modal-addGuest .guestCounter span.minus{
        background: #f2f2f2;
        border-radius: 27px 0 0 27px;
    }
    #modal-addGuest .guestCounter span svg{
        width: 17px;
        height: 100%;
        fill: #293b5a;
        display: block;
        margin:0 auto;
    }
    #modal-addGuest .guestCounter span.value{
        font-size: 1rem;
        color: #434343;
    }
    .resetGuestList{
        border-color:#c30303
    }
    .resetGuestList svg{
        fill:#c30303
    }
    .resetGuestList span{
        color:#c30303
    }

    @media only screen and (max-width:1450px){

    }
</style>
